import styled from 'styled-components';

export const Wrapper = styled.div`
	max-width: 1245px;
	width: 100%;
	padding: 0 20px;
	margin: 0 auto;

	.mo-banner-wrap {
		display: none;
	}

	.flex-wrapper {
		display: flex;

		.left {
			max-width: 880px;
			width: 100%;
			border-right: 1px solid #eee;
			padding-right: 80px;
			.result {
				display: flex;
				justify-content: center;
				height: 624px;
				position: relative;
				.result-box {
					width: 279px;
					height: 168px;
					background-image: url(/images/result.png);
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					p {
						padding-top: 44px;
						text-align: center;
						font-size: 18px;
						font-weight: 400;
						line-height: 150%;
					}
				}
			}
			.input-box {
				margin-top: 98px;
				position: relative;
				img {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 17px;
					cursor: pointer;
				}
				input {
					width: 100%;
					border-radius: 10px;
					background: #f7f7f7;
					border: none;
					padding: 13px 17px 12px 46px;
					font-size: 14px;
					font-weight: 400;
					line-height: 150%;
				}
			}
			.total-box {
				margin-top: 54px;
				p {
					font-size: 18px;
					font-weight: 400;
					line-height: 150%;
					span {
						color: #ffbc00;
					}
				}
			}
			.article-wrap {
				margin-left: 2px;
				margin-top: 54px;
				.flex-wrap {
					display: flex;
					justify-content: space-between;
				}
				.card-box {
					display: block;
					border-bottom: 1px solid #eee;
					padding-bottom: 49px;
					margin-bottom: 54px;
					&:last-child {
						border-bottom: none;
					}
				}
				.article-card {
					display: flex;
					gap: 50px;
					align-items: center;
					cursor: pointer;
					transition: all 0.3s;

					&:hover {
						opacity: 0.8;
					}

					.article-img {
						width: 250px;
						height: 0;
						padding-bottom: 70.7%;
						border-radius: 16px;
						background-repeat: no-repeat !important;
						background-size: cover !important;
						background-position: center !important;
					}
					.text-box {
						max-width: 460px;
						width: 100%;
						.tag-box {
							display: flex;
							gap: 16px;
							.cate {
								color: #e99210;
								font-size: 13px;
								font-weight: 400;
								line-height: 140%;
							}
						}
						h3 {
							margin-top: 7px;
							font-size: 28px;
							font-weight: 700;
							line-height: 140%;
							overflow: hidden;
							display: -webkit-box;
							-webkit-line-clamp: 1;
							-webkit-box-orient: vertical;
						}
						.content {
							margin-top: 9px;
							color: #888;
							font-size: 14px;
							font-weight: 300;
							line-height: 140%;
							overflow: hidden;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							padding-right: 30px;
						}
						.flex {
							display: flex;
							margin-top: 16px;
							align-items: center;
							.user-box {
								display: flex;

								.user {
									width: 16px;
									height: 16px;
									border-radius: 50%;
									background-repeat: no-repeat;
									background-size: cover;
									background-position: center;
									margin-right: 6px;
									border: 0.5px solid #eee;
									&:nth-child(2) {
										position: relative;
										left: -10px;
									}
									&:nth-child(3) {
										position: relative;
										left: -20px;
									}
								}
							}
							p {
								font-size: 13px;
								color: #000;
								font-weight: 400;
								line-height: 140%;
								margin-right: 27px;
							}
							.name {
								font-size: 13px;
								color: #000;
								font-weight: 400;
								line-height: 140%;
								margin-right: 27px;
								position: relative;
								display: flex;
								align-items: center;
								gap: 4px;
								img {
									width: 16px;
								}
								&::after {
									position: absolute;
									content: '';
									width: 1px;
									height: 12px;
									background-color: #eee;
									left: -13px;
									top: 50%;
									transform: translateY(-50%);
								}
							}
							.date {
								color: #000;
								font-size: 13px;
								font-weight: 400;
								line-height: 140%;
								position: relative;
								&::before {
									position: absolute;
									content: '';
									width: 1px;
									height: 12px;
									background-color: #eee;
									left: -13px;
									top: 50%;
									transform: translateY(-50%);
								}
							}
						}
					}
				}
			}
		}
		.right {
			margin-top: 0;
			padding-left: 40px;
			max-width: 340px;
			width: 100%;

			.series {
				margin-top: 100px;
				h3 {
					font-size: 18px;
					font-weight: 700;
					margin-bottom: 26px;
				}
				.series-list {
					.list {
						display: flex;
						align-items: center;
						gap: 24px;
						margin-top: 20px;
						cursor: pointer;
						transition: all 0.3s;
						&:hover {
							opacity: 0.8;
						}
						.seriesimg {
							width: 68px;
							height: 68px;
							background-repeat: no-repeat;
							background-size: cover;
							background-position: center;
						}
						.text-box {
							h4 {
								font-size: 16px;
								font-weight: 700;
							}
							p {
								margin-top: 6px;
								color: #666;
								font-size: 14px;
								font-weight: 400;
							}
						}
					}
				}
			}
			.tag {
				margin-top: 100px;
				h3 {
					font-size: 18px;
					font-weight: 700;
				}
				ul {
					margin-top: 26px;
					display: flex;
					flex-wrap: wrap;
					gap: 12px 10px;
					li {
						padding: 7px 18px;
						border-radius: 50px;
						border: 1px solid #eee;
						background: #fff;
						font-size: 16px;
						font-weight: 300;
						display: inline-block;
						cursor: pointer;
						transition: all 0.3s;
						&:hover {
							background: #f7f7f7;
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1100px) {
		.flex-wrapper {
			display: flex;
			.left {
				padding-right: 30px;
				.article-wrap {
					margin-top: 98px;
					margin-left: 2px;
					.article-card {
						gap: 20px;
						.article-img {
							width: 180px;
							padding-bottom: 70%;
						}
						.text-box {
							h3 {
								margin-top: 7px;
								font-size: 18px;
							}
							.flex {
								p {
									font-size: 12px;
								}
								.name {
									font-size: 12px;
								}
								.date {
									font-size: 12px;
								}
							}
						}
					}
				}
			}
			.right {
				padding-left: 30px;
				max-width: 280px;
			}
		}
	}
	@media screen and (max-width: 768px) {
		margin-top: 30px;
		padding-top: 53px;
		.flex-wrapper {
			flex-wrap: wrap;
			.left {
				max-width: 100%;
				border-right: none;
				padding-right: 0;
				.result {
					height: 400px;
					.result-box {
						width: 220px;
						height: 132px;
						p {
							padding-top: 35px;
							font-size: 14px;
						}
					}
				}
				.input-box {
					margin-top: 0;
					img {
						left: 16px;
					}
					input {
						padding: 14px 16px 14px 46px;
					}
				}
				.total-box {
					margin-top: 36px;
					p {
						font-size: 15px;
					}
				}

				.article-wrap {
					margin-top: 36px;
					margin-left: 0;

					.flex-wrap {
						flex-wrap: wrap;
						.left-box {
							width: 100%;
						}
					}
					.card-box {
						display: block;
						border-bottom: 1px solid #eee;
						padding-bottom: 30px;
						margin-bottom: 30px;
						&:last-child {
							padding-bottom: 0;
							margin-bottom: 0;
						}
					}
					.article-card {
						flex-wrap: wrap;
						gap: 20px;
						.article-img {
							width: 100%;
							height: 0;
							padding-bottom: 55.4%;
							border-radius: 16px;
							background-repeat: no-repeat;
							background-size: cover;
							background-position: center;
						}
						.text-box {
							max-width: 584px;
							width: 100%;
							margin-left: 10px;
							.tag-box {
								gap: 12px;
								.cate {
									font-size: 13px;
									font-weight: 300;
								}
							}
							h3 {
								margin-top: 6px;
								font-size: 18px;
							}
							.content {
								margin-top: 8px;
								font-size: 13px;
								padding-right: 0px;
							}
							.flex {
								margin-top: 9px;
								p {
									font-size: 12px;
								}
								.name {
									font-size: 12px;
								}
								.date {
									font-size: 12px;
								}
							}
						}
					}
					.right-box {
						display: none;
					}
				}
			}
			.mo-banner-wrap {
				width: 100%;
				display: block;
				.mo-banner {
					padding: 22px 24px;
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
					border-radius: 8px;
					p {
						font-size: 18px;
						font-weight: 600;
						line-height: 140%;
						max-width: 185px;
						word-break: keep-all;
						margin-bottom: 12px;
					}
					span {
						display: flex;
						align-items: center;
						gap: 6px;
						font-size: 12px;
						font-weight: 400;
						line-height: normal;
						img {
							width: 4px;
							height: 8px;
						}
					}
				}
				.line {
					border-bottom: 8px solid #f7f7f7;
					margin: 60px -20px 0 -20px;
				}
			}
			.right {
				padding-left: 0;
				max-width: 100%;

				.series {
					margin-top: 60px;
					h3 {
						margin-bottom: 20px;
					}
					.series-list {
						.list {
							gap: 20px;
							margin-top: 20px;
							.seriesimg {
								width: 58px;
								height: 58px;
							}
						}
					}
				}
				.tag {
					margin-top: 60px;
					ul {
						margin-top: 20px;
					}
				}
			}
		}
	}
`;

export const BannerWrapper = styled.div`
	margin-top: 100px;
	.banner {
		width: 100%;
		background: #d9d9d9;
		padding: 60px 60px 54px 60px;
		border-radius: 18px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		p {
			font-size: 30px;
			font-weight: 600;
			margin-bottom: 23px;
		}
		span {
			font-size: 18px;
			font-weight: 400;
			display: flex;
			align-items: center;
			gap: 10px;
			cursor: pointer;
			transition: all 0.3s;
			&:hover {
				opacity: 0.8;
			}
		}
	}
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
